import { getLocalStorage, setLocalStorage } from "utils/globalLocalStorage.js";

const saveMailsToLocalStorage = (emailData) => {
  // for userw who are not logged in we need to save the email in local storage
  if (emailData) {
    // get the existing emails from local storage
    const existingMails = getLocalStorage("mailsList");
    if (typeof emailData === "string") {
      // check if the email is already in the local storage
      if (existingMails?.includes(emailData)) return;
      // if not add it to the local storage
      const dataToSave = existingMails
        ? existingMails + "," + emailData
        : emailData;
      setLocalStorage("mailsList", dataToSave);
    } else {
      // if mails are in array we need to check each email and add only the new ones
      const newMails = emailData.filter(
        (mail) => !existingMails?.includes(mail)
      );
      // if no new mails we can return
      if (newMails.length === 0) return;
      // if there are new mails we need to add them to the local storage
      const dataToSave = existingMails
        ? existingMails + "," + newMails.join(",")
        : newMails.join(",");
      setLocalStorage("mailsList", dataToSave);
    }
  }
};

export default saveMailsToLocalStorage;
